import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const TaxSlabListDetails = () => { 
  const [taxSlabs, setTaxSlabs] = useState([]); 

  useEffect(() => { 
    

    fetchTaxSlabs(); 
    fetchTaxType();
  }, []); 



    const fetchTaxSlabs = async () => { 
    try { 
        const url = `${API_DOMAIN}${API_ROUTES.tax_slab}`; 
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 
        const taxSlabsWithTypeName = await Promise.all(response.data.map(async (taxSlab) => {

        const taxType = await fetchTaxType(taxSlab.tax_type);
        return { ...taxSlab, tax_type_name: taxType.name };
        }));
        // //console.log()
        setTaxSlabs(taxSlabsWithTypeName); 
    } catch (error) { 
        console.error('Error fetching tax slabs:', error); 
    } 
    };



    const fetchTaxType = async (taxType) => { 
        try {
  
            // `${API_DOMAIN}${API_ROUTES.credit_note}${id}/`
            const url = `${API_DOMAIN}${API_ROUTES.tax_type}${taxType}/`; 
            const token = localStorage.getItem('token'); 
             
            const response = await axios.get(url, { headers }); 
            return response.data; 
        } catch (error) { 
            console.error('Error fetching tax types:', error); 
        } 
    };

  const columns = [ 
    { label: 'Tax Type', value: 'tax_type_name' }, 
    { label: 'Min Income', value: 'min_income' }, 
    { label: 'Max Income', value: 'max_income' }, 
    { label: 'Rate', value: 'rate' }, 
  ]; 

  const handleViewDetails = (taxSlabId) => { 
    //console.log('View Details', taxSlabId); 
    const encodedId = btoa(taxSlabId); 
    window.location.href = `/tax/slab/details/${encodedId}`; 
  }; 

  const handleEditDetails = (taxSlabId) => {
    const encodedId = btoa(taxSlabId); 
        window.location.href = `/tax/slab/input/${encodedId}`;
    };

  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={taxSlabs} actionButtons={actionButtons} />; 
}; 

export default TaxSlabListDetails;